import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Page from '@Containers/Page';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import LoginEnforcedNotification from './LoginEnforcedNotification';
import LoginInstitutionalGreeting from './LoginInstitutionalGreeting';

import './LoginPageWrapper.scss';

function LoginPageWrapper(props) {
  const { notifications, children, className } = props;
  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
    // eslint-disable-next-line
  }, []);
  return (
    <Page
      withHeader
      headerType="unauth"
      withFooter
      className={classnames('react-page-static__wrapper', 'react-page-login-page', { [className]: className })}>
      <div className="login-page">
        <div id="hexagon-visuals" />
        <main id="main-content" className="login-page__screen" aria-label="Login screen">
          <div className="login-page__screen_container rx-container rx-container--centered">
            <div className="login-page__screen_container-additional-text">
              <LoginEnforcedNotification notifications={notifications} />
              <div className="login-page-form" role="form" aria-label="Login form">
                {children}
              </div>
              <LoginInstitutionalGreeting notifications={notifications} />
            </div>
          </div>
        </main>
      </div>
    </Page>
  );
}

LoginPageWrapper.propTypes = {
  notifications: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default LoginPageWrapper;
